import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=653e2130"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports